import type { StripeProduct, StripeSubscription } from "@/API";
import { useEffect, useState, type FC } from "react";
import Text from "@/components/Text";
import CurrentSubCard from "../CurrentSubCard";
import {
  resetUpdateSubscriptionPriceState,
  updateSubscriptionPriceState,
} from "@/store/updateSubscriptionPriceState";
import {
  currentSubscriptionState,
  getCurrentSubscription,
} from "@/store/currentSubscriptionState";
import { toast } from "sonner";
import UpdateSubscriptionDialog from "../UpdateSubscriptionDialog";

type Props = {
  stripeSubscription: StripeSubscription | null;
  listProducts: StripeProduct[] | null;
  onOpenUnsubDialog: () => void;
  stripeSubscriptionIsLoading: boolean;
  listProductsIsLoading: boolean;
};

const Subscription: FC<Props> = ({
  stripeSubscription,
  listProducts,
  onOpenUnsubDialog,
  stripeSubscriptionIsLoading,
  listProductsIsLoading,
}) => {
  const { data: updateSubPrice, isLoading: updateSubPriceIsLoading } =
    updateSubscriptionPriceState();
  const { data: userPlan } = currentSubscriptionState();
  const [openUpgradeDialog, setOpenUpgradeDialog] = useState(false);

  useEffect(() => {
    if (updateSubPrice) {
      toast.success(
        `Votre abonnement a été mis à niveau vers un abonnement annuel.`,
        {
          duration: 2000,
        },
      );
      setOpenUpgradeDialog(false);
      getCurrentSubscription();
      resetUpdateSubscriptionPriceState();
    }
  }, [updateSubPrice]);

  const product =
    listProducts &&
    stripeSubscription &&
    listProducts.find(({ prices }) =>
      prices.find((price) => price?.id === stripeSubscription.priceId),
    );

  return (
    <>
      <UpdateSubscriptionDialog
        onClose={() => setOpenUpgradeDialog(false)}
        open={openUpgradeDialog}
        isDisabled={updateSubPriceIsLoading}
        priceId="price_1SQSbhIEb2TpshBJ0d8P5NoF"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-[16px]">
        <div className="flex flex-col gap-[16px]">
          <Text fontWeight={600} fontSize={20}>
            {product?.name}
          </Text>

          <CurrentSubCard
            // haventManageAction
            haveUnsubscribeAction={Boolean(
              product && !stripeSubscription?.cancelAtPeriodEnd,
            )}
            // haveUpgradeAction={Boolean(product)}
            onOpenUnsubDialog={onOpenUnsubDialog}
            isLoading={stripeSubscriptionIsLoading || listProductsIsLoading}
            productName={product?.name ?? undefined}
            expirationDate={
              userPlan?.cancelAtPeriodEnd
                ? userPlan.currentPeriodEnd
                : undefined
            }
          />
        </div>
      </div>
    </>
  );
};

export default Subscription;
